import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnviarEmailComponent } from './enviar-email.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatIconModule, MatInputModule, MatNativeDateModule, MatPaginatorModule, MatSelectModule, MatTooltipModule } from '@angular/material';
import { NgxLoadingModule } from 'ngx-loading';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card'


const routes = [
    {
      path: 'enviar-email',
      component: EnviarEmailComponent
    }
  ];

@NgModule({
  declarations: [EnviarEmailComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    RouterModule.forChild(routes),
    SharedModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTooltipModule,
    HttpClientModule,
    NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
    MatCardModule,
    
  ],
  exports: [EnviarEmailComponent]
})
export class EnviarEmailModule { }
